module.exports = __webpack_public_path__ + "static/media/okta_btn_icon.f70c74df.png";